import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import Loading from 'wrappers/Loading';
import { ConfirmarPagoOnlineConstant } from './constants';
import { useParams } from 'react-router-dom';
import useCustomToast from 'hooks/useCustomToasts';

const ConfirmarPagoOnline = () => {
  const [loading, setLoading] = useState(true);

  const routeParams = useParams();

  const [informacion, setInformacion] = useState({
    titulo: '',
    subtitutlo: '',
    indicaciones: [],
  });

  const toast = useCustomToast();

  const requestIndicationsData = async (url) => {
    return await ApiKeyFetch.instance().post(url, {});
  };

  const init = useCallback(async () => {
    let url = ConfirmarPagoOnlineConstant.urls.indicacionesGenerales;
    let response = await requestIndicationsData(url);
    setInformacion({
      subtitutlo: '',
      indicaciones: response.data.indicaciones,
      titulo: response.data.titulo,
    });
    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  const onClickContinuar = useCallback(async () => {
    setLoading(true);
    const url = ConfirmarPagoOnlineConstant.urls.iniciarSesionPago;
    const response = await ApiKeyFetch.instance().post(url, routeParams);
    if (response?.transaccion && response?.url) {
      window.location.href = response?.url;
      return;
    } else {
      window.location.href = response?.url;
      toast.addWarningToast('Ha ocurrido un problema al realizar la petición al servidor');
    }
    setLoading(false);
  }, [routeParams, toast]);

  return (
    <React.Fragment>
      <Loading loading={loading}>
        <div className="cr-content">
          <BreadCurmb showPaths={false} />
          <div className="container">
            <div className="row">
              <div className="card card-border text-center col-12">
                <div className="card-header">
                  <h1>{informacion.titulo}</h1>
                </div>
                <div className="card-body">
                  <div className="alert alert-success mx-5 text-left" role="alert">
                    <ul className="none-list-points">
                      {informacion.indicaciones.map((element, index) => (
                        <li key={index}>
                          <h5 className="font-source-sans-regular font-17px my-1">
                            {index + 1}. {element}
                          </h5>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <Button
                    type="button"
                    color="primary"
                    onClick={onClickContinuar}
                    disabled={loading}
                  >
                    Continuar
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default ConfirmarPagoOnline;
